export default {
  name: "Queue"
}
